import React from "react";
import { toast } from "react-toastify";
import useApi from "../useApi";

interface UpdateClinicianResponse {
  status: "success" | "error";
  message: string;
  data?: any;
}

interface IClinician {
  _id: string;
  name: string;
  uploadFolder: any[];
}

interface CliniciansRes {
  status: "success" | "error";
  data: IClinician[];
  message: string;
}

const useFetchClinicians = () => {
  const [clinicians, setClinicians] = React.useState<IClinician[]>([]);
  const [loading, setLoading] = React.useState(true);

  const { makeApiCall } = useApi({
    url: "/rtm/patient-enrollment/clinician",
    method: "GET",
  });

  const { makeApiCall: makeUpdateCall } = useApi({
    url: "/rtm/patient-enrollment/clinician",
    method: "PUT",
  });

  const fetchClinicians = React.useCallback(async () => {
    try {
      setLoading(true);
      const { response, error } = await makeApiCall<undefined, CliniciansRes>();

      if (response?.status === "success") {
        setClinicians(response.data || []);
      } else {
        setClinicians([]);
        toast.error(response?.message || "Failed to fetch clinicians");
      }
    } catch (error) {
      toast.error("An error occurred while fetching clinicians");
      setClinicians([]);
    } finally {
      setLoading(false);
    }
  }, [makeApiCall]);

  // React.useEffect(() => {
  //   fetchClinicians();
  // }, [fetchClinicians]);

  const updatePatientClinician = React.useCallback(
    async (patientId: string, clinicianId: string) => {
      try {
        const { response } = await makeUpdateCall<{}, UpdateClinicianResponse>(
          {},
          `/rtm/patient-enrollment/clinician?clinicianId=${encodeURIComponent(
            clinicianId
          )}&patientId=${encodeURIComponent(patientId)}`
        );

        if (response?.status === "success") {
          toast.success(response.message || "Patient account owner updated");
          return true;
        } else {
          toast.error(response?.message || "Failed to update clinician");
          return false;
        }
      } catch (error) {
        toast.error("An error occurred while updating clinician");
        return false;
      }
    },
    []
  );

  return {
    clinicians,
    loading,
    refetch: fetchClinicians,
    updatePatientClinician,
    fetchClinicians,
  };
};

export default useFetchClinicians;

export type { IClinician };
